module.exports = __webpack_public_path__ + "static/img/manual_ja_17.a4e6b7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_17.png
// module id = hVxI
// module chunks = 4